// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as UserAvatarComponent} from './UserAvatar.svg';

import Icon, { TIconProps } from '../Icon';

export const IconUserAvatar = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <UserAvatarComponent/>
  </Icon>
));
